import { t } from 'i18next'
import { Trans } from 'react-i18next'
export const WHITELABEL_DATA = [
  {
    appname: 'everybodymusic',
    title: 'Everybody Music | Dashboard',
    code: 'W3EQ2E5S92',
    url: 'app.everybodymusic.co',
  },
  {
    appname: 'refinemedia',
    title: 'Refine Media | Dashboard',
    code: 'CBA5BF601U',
    url: 'refinemedia.musicdash.com',
  },
  {
    appname: '1888records',
    title: '1888 Records | Dashboard',
    code: 'J3MLNNUQTV',
    url: 'app.1888records.com',
  },
  {
    appname: 'mordhun',
    title: 'Mordhun | Dashboard',
    code: 'JMX33UV6J2',
    url: 'app.mordhun.in',
  },
  {
    appname: 'chikleemusic',
    title: 'Chikleemusic | Dashboard',
    code: 'RWZLL3667Q',
    url: 'app.chikleemusic.com',
  },
  {
    appname: 'unimedia',
    title: 'Unimedia | Dashboard',
    code: '1SPKY0AZ2O',
    url: 'app.unimedialm.com',
  },
  {
    appname: 'athenadistro',
    title: 'Athena Distro | Dashboard',
    code: 'A3205KRF0K',
    url: 'athenadistro.my.id',
  },
  {
    appname: 'amgmusicdistro',
    title: 'AMG Music Distro | Dashboard',
    code: 'C2IAC84CS3',
    url: 'amgmusicdistro.com',
  },
  {
    appname: 'supernaldigitalmedia',
    title: 'Supernal Digital Media | Dashboard',
    code: 'NOD8KEVAC4',
    url: 'supernaldigitalmedia.com',
  },
  {
    appname: 'zineticmusic',
    title: 'Zinetic Music | Dashboard',
    code: '4ZU2E2KS68',
    url: 'zineticmusic.com',
  },
  {
    appname: 'xylophonedigital',
    title: 'Xylophone Digital | Dashboard',
    code: 'V22COSGDXZ',
    url: 'xylophonedigital.com',
  },
  {
    appname: 'rewindmusic',
    title: 'Rewind Music | Dashboard',
    code: 'QUI922LZTZ',
    url: 'rewindmusic.com',
  },
  {
    appname: 'shreejbm',
    title: 'Shree JBM Music | Dashboard',
    code: 'S9R8Z93NBL',
    url: 'shreejbmmusic.com',
  },
  {
    appname: 'visvamusic',
    title: 'Visva Music | Dashboard',
    code: 'ML36EBWDAP',
    url: 'visvamusic.com',
  },
  {
    appname: 'distromusic',
    title: 'Distro Music | Dashboard',
    code: '19PNA4DLOE',
    url: 'distromusic.in',
  },
  {
    appname: 'nextmusicgroup',
    title: 'Next Music Group | Dashboard',
    code: 'C0LXHVE3WR',
    url: 'nextmusicgroup.com',
  },
]

export const API_URL = `https://api.musicdash.com/`
export const MARKETING_API_URL = `https://marketingapi.musicdash.ai/`
export const MASTERING_API_URL = `https://masteringapi.musicdash.ai/`
export const NEOS_API_URL = `https://admin.neos-ai.com/`
export const USER_TABLE = `filmmaker-dash-users`

export const FB_REDIRECT_URL = `https://dev.d3gj116b7zwla0.amplifyapp.com/marketing-tool/`

export const authData: {
  route: string
  title: JSX.Element
  subtitle: JSX.Element
}[] = [
  {
    route: '/signup',
    title: <Trans>{t('authLayout.signup.title')}</Trans>,
    subtitle: <Trans>{t('authLayout.signup.subtitle')}</Trans>,
  },
  {
    route: '/login',
    title: <Trans>{t('authLayout.login.title')}</Trans>,
    subtitle: <Trans>{t('authLayout.login.subtitle')}</Trans>,
  },
  {
    route: '/confirm-signup',
    title: <Trans>{t('authLayout.confirmSignup.title')}</Trans>,
    subtitle: <Trans>{t('authLayout.confirmSignup.subtitle')}</Trans>,
  },
  {
    route: '/forgot-password',
    title: <Trans>{t('authLayout.resetPassword.title')}</Trans>,
    subtitle: <Trans>{t('authLayout.resetPassword.subtitle')}</Trans>,
  },
  {
    route: '/reset-password',
    title: <Trans>{t('authLayout.resetPassword.title')}</Trans>,
    subtitle: <Trans>{t('authLayout.resetPassword.subtitle')}</Trans>,
  },
]

// export const sidebarData = [
//   {
//     title: <Trans>{t('sidebar.menu')}</Trans>,
//     route: '',
//     icon: HomeIcon,
//     routes: [
//       // {
//       //   route: '/add-submission',
//       //   name: 'add submission',
//       //   icon: PlusIcon,
//       // },
//       {
//         route: '/my-submissions',
//         name: <Trans>{t('sidebar.mySubmissions')}</Trans>,
//         icon: FilmIcon,
//       },

//       {
//         route: '/analytics',
//         name: <Trans>{t('sidebar.analytics')}</Trans>,
//         icon: PerformanceIcon,
//       },
//       // {
//       //   route: '/create-youtube-channel',
//       //   name: 'Create channel',
//       //   icon: YoutubeIcon,
//       // },
//       {
//         route: '/bulk-Submission',
//         name: <Trans>{t('sidebar.bulkSubmission')}</Trans>,
//         icon: UploadBulk,
//       },
//     ],
//   },
//   // {
//   //   title: 'admin',
//   //   route: '/admin',
//   //   icon: KeyIcon,
//   //   routes: [
//   //     {
//   //       route: '/qc',
//   //       name: 'quality check',
//   //       icon: QCIcon,
//   //     },
//   //     {
//   //       route: '/pending',
//   //       name: 'pending',
//   //       icon: PendingIcon,
//   //     },
//   //   ],
//   // },
//   // {
//   //   title: 'auth',
//   //   route: '/admin',
//   //   icon: AuthIcon,
//   //   routes: [
//   //     {
//   //       route: '/users',
//   //       name: 'users',
//   //       icon: UserIcon,
//   //     },
//   //   ],
//   // },
// ]

export const genres = [
  { name: 'Action/Adventure' },
  { name: 'Animation' },
  { name: 'Comedy' },
  { name: 'Crime' },
  { name: 'Documentary' },
  { name: 'Fantasy' },
  { name: 'Horror' },
  { name: 'Informational & Educational' },
  { name: 'Music & Performances' },
  { name: 'Mystery' },
  { name: 'Reality Show' },
  { name: 'Sci-Fi' },
  { name: 'Sport & Fitness' },
  { name: 'Thriller' },
  { name: 'Unknown' },
  { name: 'War' },
  { name: 'Western' },
]
export const languages = [
  { name: 'Afrikaans' },
  { name: 'Akan' },
  { name: 'Albanian' },
  { name: 'Amharic' },
  { name: 'Arabic' },
  { name: 'Armenian' },
  { name: 'Azerbaijani' },
  { name: 'Basque' },
  { name: 'Belarusian' },
  { name: 'Bengali' },
  { name: 'Bosnian' },
  { name: 'Bulgarian' },
  { name: 'Burmese' },
  { name: 'Cambodian Khmer' },
  { name: 'Catalan' },
  { name: 'Croatian' },
  { name: 'Czech' },
  { name: 'Danish' },
  { name: 'Dari' },
  { name: 'Dutch' },
  { name: 'Estonian' },
  { name: 'English' },
  { name: 'Farsi' },
  { name: 'Filipino' },
  { name: 'Finnish' },
  { name: 'French' },
  { name: 'Gaelic' },
  { name: 'Galician' },
  { name: 'Georgian' },
  { name: 'German' },
  { name: 'Greek' },
  { name: 'Guarani' },
  { name: 'Gujarati' },
  { name: 'Hebrew' },
  { name: 'Hindi' },
  { name: 'Hungarian' },
  { name: 'Icelandic' },
  { name: 'Indonesian' },
  { name: 'Italian' },
  { name: 'Japanese' },
  { name: 'Javanese' },
  { name: 'Kannada' },
  { name: 'Kazakh' },
  { name: 'Korean' },
  { name: 'Kurdish' },
  { name: 'Latvian' },
  { name: 'Lithuanian' },
  { name: 'Luxembourgish' },
  { name: 'Macedonian' },
  { name: 'Malay' },
  { name: 'Malayalam' },
  { name: 'Maltese' },
  { name: 'Mandarin (Spoken)' },
  { name: 'Manipuri' },
  { name: 'Marathi' },
  { name: 'Moldovan' },
  { name: 'Mongolian' },
  { name: 'Nepali' },
  { name: 'No Language' },
  { name: 'Norwegian' },
  { name: 'Odia' },
  { name: 'Pashto' },
  { name: 'Polish' },
  { name: 'Portuguese' },
  { name: 'Portuguese (Brazil)' },
  { name: 'Punjabi' },
  { name: 'Romanian' },
  { name: 'Russian' },
  { name: 'Samoan' },
  { name: 'Serbian' },
  { name: 'Slovak' },
  { name: 'Slovenian' },
  { name: 'Somali' },
  { name: 'Southern Balochi' },
  { name: 'Spanish (Latin America)' },
  { name: 'Spanish (Spain)' },
  { name: 'Swahili' },
  { name: 'Swedish' },
  { name: 'Tagalog' },
  { name: 'Tajik' },
  { name: 'Tamil' },
  { name: 'Telugu' },
  { name: 'Thai' },
  { name: 'Turkish' },
  { name: 'Turkmen' },
  { name: 'Ukrainian' },
  { name: 'Unknown' },
  { name: 'Urdu' },
  { name: 'Uzbek' },
  { name: 'Vietnamese' },
  { name: 'Xhosa' },
  { name: 'Yiddish' },
  { name: 'Yoruba' },
  { name: 'Zulu' },
]

export const languagesSelect = [
  {
    language: 'albanian',
    translation: 'Shqip',
    code: 'sq',
  },
  {
    language: 'arabic',
    translation: 'العربية',
    code: 'ar',
  },
  {
    language: 'azerbaijani',
    translation: 'Azərbaycan dili',
    code: 'az',
  },
  {
    language: 'bengali',
    translation: 'বাংলা',
    code: 'bn',
  },
  // {
  //   language: 'berber',
  //   translation: 'ⵜⴰⵎⴰⵣⵉⵖⵜ',
  //   code: 'ber',
  // },
  {
    language: 'chinese',
    translation: '中文',
    code: 'zh',
  },
  // {
  //   language: 'comorian',
  //   translation: 'Shikomor',
  //   code: 'swb',
  // },
  {
    language: 'dari',
    translation: 'دری',
    code: 'fa-AF',
  },
  {
    language: 'dhivehi',
    translation: 'ދިވެހި',
    code: 'dv',
  },
  {
    language: 'dutch',
    translation: 'Nederlands',
    code: 'nl',
  },
  {
    language: 'english',
    translation: 'English',
    code: 'en',
  },
  {
    language: 'french',
    translation: 'Français',
    code: 'fr',
  },
  {
    language: 'hindi',
    translation: 'हिन्दी',
    code: 'hi',
  },
  {
    language: 'indonesian',
    translation: 'Bahasa Indonesia',
    code: 'id',
  },
  {
    language: 'kurdish',
    translation: 'Kurdî',
    code: 'ku',
  },
  {
    language: 'kyrgyz',
    translation: 'Кыргызча',
    code: 'ky',
  },
  {
    language: 'malay',
    translation: 'Bahasa Melayu',
    code: 'ms',
  },
  {
    language: 'pashto',
    translation: 'پښتو',
    code: 'ps',
  },
  {
    language: 'persian',
    translation: 'فارسی',
    code: 'fa',
  },
  {
    language: 'portuguese',
    translation: 'Português',
    code: 'pt',
  },
  {
    language: 'russian',
    translation: 'Русский',
    code: 'ru',
  },
  {
    language: 'somali',
    translation: 'Soomaaliga',
    code: 'so',
  },
  {
    language: 'spanish',
    translation: 'Español',
    code: 'es',
  },
  {
    language: 'swahili',
    translation: 'Kiswahili',
    code: 'sw',
  },
  {
    language: 'tajik',
    translation: 'тоҷикӣ',
    code: 'tg',
  },
  {
    language: 'tamil',
    translation: 'தமிழ்',
    code: 'ta',
  },
  {
    language: 'turkmen',
    translation: 'Türkmençe',
    code: 'tk',
  },
  {
    language: 'turkish',
    translation: 'Türkçe',
    code: 'tr',
  },
  {
    language: 'urdu',
    translation: 'اردو',
    code: 'ur',
  },
  {
    language: 'uzbek',
    translation: 'Oʻzbek tili',
    code: 'uz',
  },
]

export const subgenres = [
  { name: 'Action' },
  { name: 'Adventure' },
  { name: 'Bollywood' },
  { name: 'Christmas' },
  { name: 'Courtroom / Legal Drama' },
  { name: 'Crime' },
  { name: 'Disaster' },
  { name: 'Drama' },
  { name: 'Educational' },
  { name: 'Experimental' },
  { name: 'Faith and Religion' },
  { name: 'Family' },
  { name: 'Fantasy' },
  { name: 'Film Noir' },
  { name: 'Gangster' },
  { name: 'History' },
  { name: 'Horror' },
  { name: 'Japanimation' },
  { name: 'Kids' },
  { name: 'LGBTQ+' },
  { name: 'Martial Arts' },
  { name: 'Military' },
  { name: 'Mockumentary' },
  { name: 'Music' },
  { name: 'Musical' },
  { name: 'Mystery' },
  { name: 'Period Drama' },
  { name: 'Pirates' },
  { name: 'Procedural Drama' },
  { name: 'Romance / Love' },
  { name: 'Rom-Com' },
  { name: 'Sex' },
  { name: 'Sports' },
  { name: 'Superhero' },
  { name: 'Suspense' },
  { name: 'War' },
  { name: 'Western' },
]

export const formats = [
  { name: 'Feature Film' },
  { name: 'Short Film' },
  { name: 'Documentary' },
  { name: 'Episodic Show' },
]

export const moods = [
  { name: 'Anger' },
  { name: 'Anxiety' },
  { name: 'Calm' },
  { name: 'Exciting' },
  { name: 'Fear' },
  { name: 'Feel-good' },
  { name: 'Funny' },
  { name: 'Joy' },
  { name: 'Powerful' },
  { name: 'Sad' },
]

export const keywords = [
  { name: 'Adaptation' },
  { name: 'Adrenalin' },
  { name: 'Alien' },
  { name: 'African' },
  { name: 'Anime' },
  { name: 'Apocalypse' },
  { name: 'Asian' },
  { name: 'Avant-garde' },
  { name: 'Award' },
  { name: 'BAFTA' },
  { name: 'Best in Fest' },
  { name: 'Biography' },
  { name: 'Car chase' },
  { name: 'Cartoon' },
  { name: 'Chick flick' },
  { name: 'Christmas' },
  { name: 'Classic' },
  { name: 'Coming of age' },
  { name: 'Courtroom' },
  { name: 'Cult' },
  { name: 'Cyborg' },
  { name: 'Death' },
  { name: 'Demon / Devil' },
  { name: 'Disability' },
  { name: 'Destruction' },
  { name: 'Drugs' },
  { name: 'Dystopia' },
  { name: 'Epic' },
  { name: 'Espionage' },
  { name: 'Fairytale' },
  { name: 'Family' },
  { name: 'Female' },
  { name: 'Femme Fatale' },
  { name: 'Festival' },
  { name: 'Flight' },
  { name: 'Film School' },
  { name: 'Found Footage' },
  { name: 'Futuristic' },
  { name: 'Game' },
  { name: 'Gang' },
  { name: 'Gay' },
  { name: 'Ghost' },
  { name: 'God' },
  { name: 'Gore' },
  { name: 'Gorilla Film Making' },
  { name: 'Halloween' },
  { name: 'Heist' },
  { name: 'Hispanic' },
  { name: 'Jesus' },
  { name: 'Kidnap' },
  { name: 'Kung Fu' },
  { name: 'Lesbian' },
  { name: 'Magic' },
  { name: 'Medieval' },
  { name: 'Midnight' },
  { name: 'Miracle' },
  { name: 'Mockumentary' },
  { name: 'Monster' },
  { name: 'Murder' },
  { name: 'Mythical' },
  { name: 'Nightmare' },
  { name: 'Oscar' },
  { name: 'Paranormal' },
  { name: 'Parenthood' },
  { name: 'Parody' },
  { name: 'Police' },
  { name: 'Politics' },
  { name: 'Psychopaths' },
  { name: 'Prank' },
  { name: 'Quest' },
  { name: 'Race issues' },
  { name: 'Relationship' },
  { name: 'Religion' },
  { name: 'Remake' },
  { name: 'Road Movie' },
  { name: 'Robbery' },
  { name: 'Robot' },
  { name: 'Santa' },
  { name: 'Satire' },
  { name: 'School' },
  { name: 'Sex' },
  { name: 'Slapstick' },
  { name: 'Slasher' },
  { name: 'South American' },
  { name: 'Space' },
  { name: 'Spiritual' },
  { name: 'Spoof' },
  { name: 'Star / Celebrity' },
  { name: 'Strong female' },
  { name: 'Suicide' },
  { name: 'Superhero' },
  { name: 'Supernatural' },
  { name: 'Terrorism' },
  { name: 'Time Travel' },
  { name: 'Tragedy' },
  { name: 'Utopian' },
  { name: 'Valentine' },
  { name: 'Vampire' },
  { name: 'Vengeance / Revenge' },
  { name: 'Vintage' },
  { name: 'Violence' },
  { name: 'Virtual Reality(VR)' },
  { name: 'Werewolf' },
  { name: 'Youth' },
  { name: 'Zombie' },
]

// export const dsps = [
//   {
//     id: 37,
//     dsp_id: '247916',
//     dsp_name: '7Digital',
//   },
//   {
//     id: 42,
//     dsp_id: 'amazon_direct',
//     dsp_name: 'Amazon (Direct)',
//   },
//   {
//     id: 35,
//     dsp_id: '20799134',
//     dsp_name: 'Anghami',
//   },
//   {
//     id: 34,
//     dsp_id: '847103579',
//     dsp_name: 'AWA',
//   },
//   {
//     id: 33,
//     dsp_id: '1158892521',
//     dsp_name: 'Bmat',
//   },
//   {
//     id: 32,
//     dsp_id: '2100357',
//     dsp_name: 'Deezer',
//   },
//   {
//     id: 31,
//     dsp_id: '1499657856',
//     dsp_name: 'Facebook Audio Library',
//   },
//   {
//     id: 30,
//     dsp_id: '1415672002',
//     dsp_name: 'Facebook Fingerprinting',
//   },
//   {
//     id: 38,
//     dsp_id: '2721730765',
//     dsp_name: 'Facebook Video',
//   },
//   {
//     id: 39,
//     dsp_id: '2929664894',
//     dsp_name: 'Facebook Video Fingerprinting',
//   },
//   {
//     id: 29,
//     dsp_id: '1988507361',
//     dsp_name: 'fizy',
//   },
//   {
//     id: 28,
//     dsp_id: '1268816855',
//     dsp_name: 'Hungama',
//   },
//   {
//     id: 27,
//     dsp_id: '3441649',
//     dsp_name: 'iHeartRadio',
//   },
//   {
//     id: 26,
//     dsp_id: '103725',
//     dsp_name: 'iMusica',
//   },
//   {
//     id: 25,
//     dsp_id: '1186352005',
//     dsp_name: 'Jaxsta Music',
//   },
//   {
//     id: 24,
//     dsp_id: '316911752',
//     dsp_name: 'JioSaavn',
//   },
//   {
//     id: 23,
//     dsp_id: '1517454273',
//     dsp_name: 'Joox',
//   },
//   {
//     id: 22,
//     dsp_id: '121452605',
//     dsp_name: 'KkBox',
//   },
//   {
//     id: 21,
//     dsp_id: '1226212715',
//     dsp_name: 'Kuack Media',
//   },
//   {
//     id: 20,
//     dsp_id: '1232212955',
//     dsp_name: 'LINE Music',
//   },
//   {
//     id: 12,
//     dsp_id: '78395129',
//     dsp_name: "Music in 'Ayoba'",
//   },
//   {
//     id: 19,
//     dsp_id: '103731',
//     dsp_name: 'Napster',
//   },
//   {
//     id: 18,
//     dsp_id: '1674795424',
//     dsp_name: 'Naver Music',
//   },
//   {
//     id: 17,
//     dsp_id: '1382854531',
//     dsp_name: 'NetEase Cloud Music',
//   },
//   {
//     id: 16,
//     dsp_id: '464139',
//     dsp_name: 'Nuuday A/S',
//   },
//   {
//     id: 15,
//     dsp_id: '9940949',
//     dsp_name: 'Qobuz',
//   },
//   {
//     id: 14,
//     dsp_id: '1963181516',
//     dsp_name: 'Resso',
//   },
//   {
//     id: 13,
//     dsp_id: '4266325',
//     dsp_name: 'Shazam',
//   },
//   {
//     id: 11,
//     dsp_id: '16149060',
//     dsp_name: 'Slacker',
//   },
//   {
//     id: 10,
//     dsp_id: '1461025062',
//     dsp_name: 'Tencent',
//   },
//   {
//     id: 9,
//     dsp_id: '3440259',
//     dsp_name: 'TIDAL',
//   },
//   {
//     id: 8,
//     dsp_id: '1809226414',
//     dsp_name: 'TikTok',
//   },
//   {
//     id: 7,
//     dsp_id: '1207204780',
//     dsp_name: 'TIM Music',
//   },
//   {
//     id: 6,
//     dsp_id: '1130831671',
//     dsp_name: 'TouchTunes / PlayNetwork',
//   },
//   {
//     id: 40,
//     dsp_id: '3373969336',
//     dsp_name: 'Triller',
//   },
//   {
//     id: 5,
//     dsp_id: '1130737243',
//     dsp_name: 'Ultimate China (Aggregation Only)',
//   },
//   {
//     id: 41,
//     dsp_id: '1130737243',
//     dsp_name: 'Ultimate China (Aggregation Only)',
//   },
//   {
//     id: 4,
//     dsp_id: '1210987244',
//     dsp_name: 'United Media Agency (UMA)',
//   },
//   {
//     id: 3,
//     dsp_id: '1234931270',
//     dsp_name: 'Xiami',
//   },
//   {
//     id: 2,
//     dsp_id: '1209287754',
//     dsp_name: 'Yandex Music',
//   },
//   {
//     id: 1,
//     dsp_id: '13285026',
//     dsp_name: 'YouTube Music',
//   },
// ]

export const dsps = [
  {
    dsp_name: '7Digital',
    dsp_id: 247916,
  },
  {
    dsp_name: 'Amazon',
    dsp_id: 42,
  },
  {
    dsp_name: 'Anghami',
    dsp_id: 20799134,
  },
  {
    dsp_name: 'Audible Magic - Rights360',
    dsp_id: 8771887,
  },
  {
    dsp_name: 'AWA',
    dsp_id: 847103579,
  },
  {
    dsp_name: 'Bmat',
    dsp_id: 1158892521,
  },
  {
    dsp_name: 'Boomplay',
    dsp_id: 1514168496,
  },
  {
    dsp_name: 'Deezer',
    dsp_id: 2100357,
  },
  {
    dsp_name: 'Dreamus Company (FLO)',
    dsp_id: 2215088010,
  },
  {
    dsp_name: 'Facebook Audio Library',
    dsp_id: 1499657856,
  },
  {
    dsp_name: 'Facebook Fingerprinting',
    dsp_id: 1415672002,
  },
  {
    dsp_name: 'fizy',
    dsp_id: 1988507361,
  },
  {
    dsp_name: 'Genie Music',
    dsp_id: 2697871022,
  },
  {
    dsp_name: 'Gracenote',
    dsp_id: 9538495,
  },
  {
    dsp_name: 'Hungama',
    dsp_id: 1268816855,
  },
  {
    dsp_name: 'iHeartRadio',
    dsp_id: 3441649,
  },
  {
    dsp_name: 'iMusica',
    dsp_id: 103725,
  },
  {
    dsp_name: 'Jaxsta Music',
    dsp_id: 1186352005,
  },
  {
    dsp_name: 'JioSaavn',
    dsp_id: 316911752,
  },
  {
    dsp_name: 'Joox',
    dsp_id: 1517454273,
  },
  {
    dsp_name: 'KkBox',
    dsp_id: 121452605,
  },
  {
    dsp_name: 'Kuack Media',
    dsp_id: 1226212715,
  },
  {
    dsp_name: 'Lickd',
    dsp_id: 1261627684,
  },
  {
    dsp_name: 'Napster',
    dsp_id: 103731,
  },
  {
    dsp_name: 'NAVER VIBE',
    dsp_id: 1674795424,
  },
  {
    dsp_name: 'NetEase Cloud Music',
    dsp_id: 1382854531,
  },
  {
    dsp_name: 'Pandora',
    dsp_id: 7851192,
  },
  {
    dsp_name: 'Peloton',
    dsp_id: 2528780514,
  },
  {
    dsp_name: 'Pretzel Rocks',
    dsp_id: 2406442214,
  },
  {
    dsp_name: 'Qobuz',
    dsp_id: 9940949,
  },
  {
    dsp_name: 'SoundCloud',
    dsp_id: 35299696,
  },
  {
    dsp_name: 'Spotify',
    dsp_id: 746109,
  },
  {
    dsp_name: 'Taobao',
    dsp_id: 1234931270,
  },
  {
    dsp_name: 'Tencent',
    dsp_id: 1461025062,
  },
  {
    dsp_name: 'Tdsp_idAL',
    dsp_id: 3440259,
  },
  {
    dsp_name: 'TikTok',
    dsp_id: 1809226414,
  },
  {
    dsp_name: 'TikTok Music',
    dsp_id: 1963181516,
  },
  {
    dsp_name: 'TouchTunes',
    dsp_id: 1130831671,
  },
  {
    dsp_name: 'United Media Agency (UMA)',
    dsp_id: 1210987244,
  },
  {
    dsp_name: 'Xite',
    dsp_id: 1553828531,
  },
  {
    dsp_name: 'Yandex Music',
    dsp_id: 1209287754,
  },
  {
    dsp_name: 'YouTube Music & Content',
    dsp_id: 3405271817,
  },
]

export const artistOptions = [
  { name: 'JayZ', options: ['Age 18 and Over', 'Pop Music'] },
  { name: 'Adele', options: ['Age 25 and Over', 'Pop Music'] },
]

export const additionalOptions = [
  'Age 18 and Over',
  'Pop Music',
  'Lynx',
  'Taylor Swift',
]

export const countriesList = [
  { name: 'All', code: 'ALL' },
  { name: 'Brazil', code: 'BR' },
  { name: 'India', code: 'IN' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'Canada', code: 'CA' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Egypt', code: 'EG' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'Germany', code: 'DE' },
  { name: 'Greece', code: 'GR' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Norway', code: 'NO' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Panama', code: 'PA' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Poland', code: 'PL' },
  // { name: 'Russia', code: 'RU' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Singapore', code: 'SG' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Korea', code: 'KR' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Taiwan', code: 'TW' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Turkey', code: 'TR' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Iceland', code: 'IS' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Romania', code: 'RO' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Palestine', code: 'PS' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'Malta', code: 'MT' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Oman', code: 'OM' },
  { name: 'North Macedonia', code: 'MK' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'Albania', code: 'AL' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Macau', code: 'MO' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Brunei', code: 'BN' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Libya', code: 'LY' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Guam', code: 'GU' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Aruba', code: 'AW' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Grenada', code: 'GD' },
  { name: 'U.S. Virgin Islands', code: 'VI' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Mali', code: 'ML' },
  { name: 'Angola', code: 'AO' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Togo', code: 'TG' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Congo - Brazzaville', code: 'CG' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Eswatini', code: 'SZ' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Laos', code: 'LA' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'British Virgin Islands', code: 'VG' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Åland Islands', code: 'AX' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Niger', code: 'NE' },
  { name: 'Congo - Kinshasa', code: 'CD' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Samoa', code: 'WS' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Falkland Islands', code: 'FK' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Palau', code: 'PW' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Somalia', code: 'SO' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Vatican City', code: 'VA' },
  { name: 'Chad', code: 'TD' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Zimbabwe', code: 'ZW' },
  { name: 'Ivory Coast', code: 'CI' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Bonaire', code: 'BQ' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Curacao', code: 'CW' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Heard Island and McDonald Islands', code: 'HM' },
  { name: 'Kosovo', code: 'XK' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Pitcairn Islands', code: 'PN' },
  { name: 'Saint Barthelemy', code: 'BL' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Martin', code: 'MF' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Sint Maarten', code: 'SX' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'South Sudan', code: 'SS' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
]

export const ctaOptions = [
  { name: 'Shop Now', value: 'SHOP_NOW' },
  { name: 'Book Travel', value: 'BOOK_TRAVEL' },
  { name: 'Learn More', value: 'LEARN_MORE' },
  { name: 'Sign Up', value: 'SIGN_UP' },
  { name: 'Download', value: 'DOWNLOAD' },
  { name: 'Install Mobile App', value: 'INSTALL_MOBILE_APP' },
  { name: 'Use Mobile App', value: 'USE_MOBILE_APP' },
  { name: 'Watch Video', value: 'WATCH_VIDEO' },
  { name: 'Watch More', value: 'WATCH_MORE' },
  { name: 'Open Link', value: 'OPEN_LINK' },
]

export const ctaOptionsSpotify = [
  { name: 'Apply Now', value: 'APPLY_NOW' },
  { name: 'Book Now', value: 'BOOK_NOW' },
  { name: 'Buy Now', value: 'BUY_NOW' },
  { name: 'Buy Tickets', value: 'BUY_TICKETS' },
  { name: 'Click Now', value: 'CLICK_NOW' },
  { name: 'Download', value: 'DOWNLOAD' },
  { name: 'Find Stores', value: 'FIND_STORES' },
  { name: 'Get Coupon', value: 'GET_COUPON' },
  { name: 'Get Info', value: 'GET_INFO' },
  { name: 'Learn More', value: 'LEARN_MORE' },
  { name: 'Listen Now', value: 'LISTEN_NOW' },
  { name: 'More Info', value: 'MORE_INFO' },
  { name: 'Pre-Save', value: 'PRE_SAVE' },
  { name: 'Save Now', value: 'SAVE_NOW' },
  { name: 'Share', value: 'SHARE' },
  { name: 'Shop Now', value: 'SHOP_NOW' },
  { name: 'Sign Up', value: 'SIGN_UP' },
  { name: 'Visit Profile', value: 'VISIT_PROFILE' },
  { name: 'Visit Site', value: 'VISIT_SITE' },
  { name: 'Watch Now', value: 'WATCH_NOW' },
]
